var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.15015 0C8.56436 0 8.90015 0.335786 8.90015 0.75V8.56544L9.95144 7.50982C10.2437 7.21633 10.7186 7.21535 11.0121 7.50764C11.3056 7.79994 11.3066 8.27481 11.0143 8.5683L8.70833 10.8837C8.57103 11.0366 8.37182 11.1328 8.15015 11.1328C7.92935 11.1328 7.73083 11.0374 7.59359 10.8855L5.28584 8.5683C4.99355 8.27481 4.99453 7.79994 5.28802 7.50764C5.58152 7.21535 6.05639 7.21633 6.34868 7.50982L7.40015 8.56562V0.75C7.40015 0.335786 7.73593 0 8.15015 0ZM12.6028 5.28906C13.8165 5.28906 14.8 6.27234 14.8 7.48706V11.3943C14.8 12.604 13.8198 13.5843 12.61 13.5843H3.698C2.48421 13.5843 1.5 12.6 1.5 11.3863V7.47826C1.5 6.26954 2.48075 5.28906 3.69 5.28906H4.4436C4.85781 5.28906 5.1936 4.95328 5.1936 4.53906C5.1936 4.12485 4.85781 3.78906 4.4436 3.78906H3.69C1.65285 3.78906 0 5.44058 0 7.47826V11.3863C0 13.4285 1.65579 15.0843 3.698 15.0843H12.61C14.6482 15.0843 16.3 13.4325 16.3 11.3943V7.48706C16.3 5.44418 14.6451 3.78906 12.6028 3.78906H11.8564C11.4422 3.78906 11.1064 4.12485 11.1064 4.53906C11.1064 4.95328 11.4422 5.28906 11.8564 5.28906H12.6028Z",
    fill: "#0A74DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/Union.bd23963661b754a04b864fdaab8db2ac.svg";
export { ForwardRef as ReactComponent };